module.exports = __webpack_public_path__ + "img/bg_9.fb72b044.png";